<template>
    <div class="tools-wrapper">
        <Select
            class="tools-type-select"
            :config="{ initLabel: data.toolName || '' }"
            :initValue="initToolId"
            :topOrBottom="41"
            :options="toolsTypeOption"
            @menuClick="toolsSelected"
        >
            <!-- 这期暂时用不到，先隐藏 -->
            <Search v-show="false" :placeholder="toolsSelectedLabel" @searchChange="searchChange" @inputChange="searchChange" class="scene-search" />
        </Select>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";

export default {
    name: "Tool",
    props: ["data"],
    components: {
        Select,
        Search
    },
    computed: {
        initToolId() {
            return this.data.toolId || "def";
        },
        toolsTypeOption() {
            // 这期暂时写死数据
            return [
                {
                    label: this.$t("zhiji.answer.selectToolsType"),
                    value: "def"
                },
                {
                    label: this.$t("zhiji.answer.banEnquiry"),
                    value: "800010001"
                }
            ];
        },
        toolsSelectedLabel() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        toolsSelected(data) {
            this.commitStore({
                toolId: data.value + "",
                toolName: data.label
            });
        },
        searchChange() {
            // TODO 暂时不需要
        },
        commitStore(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: widget
            });
        }
    }
};
</script>

<style lang="less" scoped>
.tools-wrapper {
    position: relative;
    width: 350px;
    padding: 14px;
    border-radius: 8px;
    background: #f2f7fb;
    .tools-type-select {
        width: 100%;
        color: #9b9ba3;
        background: #fff;
        .scene-search {
            width: 100%;
            position: absolute;
            left: 0;
            top: 42px;
            padding: 7px 0;
            background: #fff;
            z-index: 1;
        }
    }
}
</style>
